import { entityGenerateTypeLabel } from "~shared/agenticChat/entityGenerateUserMessageContent";
import type { CTAAction } from "./cta-types";
import { CTACollapsedInstructions } from "./CTACollapsedInstructions";

type Props = {
  ctaAction: CTAAction;
};

export const CTAEntityGenerateDetails: React.FC<Props> = ({ ctaAction }) => {
  const typeLabel = entityGenerateTypeLabel({
    role: ctaAction.role,
    roleLabel: ctaAction.roleLabel,
    roleExplicitlySelected: ctaAction.roleExplicitlySelected,
  });
  const description = ctaAction.customInstructions?.trim() ?? "";

  if (!typeLabel && !description) return null;

  return (
    <>
      {typeLabel ? <CTACollapsedInstructions label="Type" instructions={typeLabel} /> : null}
      {description ? <CTACollapsedInstructions label="Description" instructions={description} /> : null}
    </>
  );
};
